var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoEngineBenefits5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2716_11811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0007 45.4679C3.00556 43.6865 3.71665 41.9796 4.97806 40.7217C6.23947 39.4637 7.94825 38.7573 9.72972 38.7573H59.2125C61.7828 38.7119 64.2325 37.6589 66.0342 35.8252C67.8358 33.9914 68.8453 31.5235 68.8453 28.9528C68.8453 26.3821 67.8358 23.9141 66.0342 22.0804C64.2325 20.2466 61.7828 19.1937 59.2125 19.1483H9.48197V16.0713L1.4622 20.7021L9.48197 25.3329V22.2742H59.2125C60.9923 22.2742 62.6992 22.9812 63.9577 24.2397C65.2162 25.4982 65.9232 27.2051 65.9232 28.9849C65.9232 30.7647 65.2162 32.4716 63.9577 33.7301C62.6992 34.9885 60.9923 35.6956 59.2125 35.6956H9.71443C7.11858 35.6956 4.62904 36.7268 2.7935 38.5623C0.957955 40.3978 -0.0732422 42.8874 -0.0732422 45.4832C-0.0732422 48.0791 0.957955 50.5686 2.7935 52.4042C4.62904 54.2397 7.11858 55.2709 9.71443 55.2709H67.4617V52.148H9.71443C7.93842 52.1521 6.23349 51.4507 4.97451 50.198C3.71553 48.9453 3.00556 47.2439 3.0007 45.4679Z",
    fill: "#525C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9111 59.204L34.4618 67.499V45.4982L15.9111 37.2031V59.204Z",
    fill: "#FFBD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4618 28.9365L15.9111 37.204L23.0898 40.4064H23.1051L41.6252 32.1389L34.4618 28.9365ZM44.7939 33.5367H44.7786L26.2432 41.8348L34.4618 45.4991L53.0125 37.204L44.7939 33.5367Z",
    fill: "#E49A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.794 33.5365L41.6252 32.1387L23.1051 40.4062H23.0898L26.2433 41.8346L44.7787 33.5365H44.794ZM53.0126 59.2046L34.4619 67.4997V45.4988L53.0126 37.2038V59.2046Z",
    fill: "#FDDC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.462 1.50003C33.0942 1.49681 31.7393 1.76342 30.4748 2.2846C29.2102 2.80578 28.0609 3.57128 27.0926 4.53728C26.1244 5.50327 25.3562 6.65078 24.832 7.91409C24.3079 9.1774 24.0381 10.5317 24.0381 11.8994C24.0381 20.2251 34.462 33.0591 34.462 33.0591C34.462 33.0591 44.8889 20.2128 44.8889 11.8994C44.8848 9.13781 43.7841 6.49086 41.8288 4.54069C39.8734 2.59051 37.2236 1.49678 34.462 1.50003Z",
    fill: "#FB3934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2638 12.0035C39.2638 13.2787 38.7573 14.5017 37.8556 15.4034C36.9538 16.3051 35.7309 16.8117 34.4557 16.8117C33.1804 16.8117 31.9575 16.3051 31.0557 15.4034C30.154 14.5017 29.6475 13.2787 29.6475 12.0035C29.6475 10.7283 30.154 9.50531 31.0557 8.6036C31.9575 7.70189 33.1804 7.19531 34.4557 7.19531C35.7309 7.19531 36.9538 7.70189 37.8556 8.6036C38.7573 9.50531 39.2638 10.7283 39.2638 12.0035Z",
    fill: "#E2E2E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2716_11811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoEngineBenefits5);
export default __webpack_public_path__ + "static/media/products_bruno_engine_benefits_5.e7bccc525c7bfedabd509ae81d852942.svg";
export { ForwardRef as ReactComponent };